import { useSiteContent } from "@/hooks/useSiteContent";
import { MapPin, Phone, Clock, Mail } from "lucide-react";
import { Link } from "react-router-dom";

export function Footer() {
  const { content } = useSiteContent();
  return (
    <footer className="bg-primary text-primary-foreground">
      <div className="container grid gap-10 py-14 md:grid-cols-4">
        <div className="md:col-span-2">
          <div className="text-2xl font-extrabold">{content.shop_name}</div>
          <p className="mt-1 text-sm text-primary-foreground/70 font-medium">{content.brand_tagline}</p>
          <p className="mt-4 max-w-md text-sm text-primary-foreground/80">
            {content.footer_about}
          </p>
        </div>
        <div>
          <h4 className="font-semibold text-accent">Contact</h4>
          <ul className="mt-4 space-y-3 text-sm text-primary-foreground/80">
            <li className="flex gap-2"><MapPin className="h-4 w-4 mt-0.5 flex-shrink-0" /> {content.shop_address}</li>
            <li className="flex gap-2"><Phone className="h-4 w-4 mt-0.5" /> <a href={`tel:${content.shop_phone}`} className="hover:text-accent">{content.shop_phone}</a></li>
            <li className="flex gap-2"><Mail className="h-4 w-4 mt-0.5" /> <a href={`mailto:${content.shop_email}`} className="hover:text-accent break-all">{content.shop_email}</a></li>
          </ul>
        </div>
        <div>
          <h4 className="font-semibold text-accent">Hours</h4>
          <ul className="mt-4 space-y-3 text-sm text-primary-foreground/80">
            <li className="flex gap-2"><Clock className="h-4 w-4 mt-0.5" /> {content.shop_hours}</li>
          </ul>
          <Link to="/admin" className="mt-6 inline-block text-xs text-primary-foreground/50 hover:text-accent">Admin</Link>
        </div>
      </div>
      <div className="border-t border-primary-foreground/10 py-5 text-center text-xs text-primary-foreground/60">
        © {new Date().getFullYear()} {content.shop_name}. All rights reserved.
      </div>
    </footer>
  );
}
